module.exports = __webpack_public_path__ + "static/probna-a9e9cbf02d319f8dec1c108a9315f89d.jpg";